interface AppEnvVariables {
  API_SERVER: string;
  APP_ENVIRONMENT: string;
  BRAZE_API_KEY: string;
  GATEWAY_URL: string;
  LOG_IN_URL: string;
  PRODUCT_CATALOG_URL: string;
  SPLIT_IO_AUTH_KEY: string;
  SENTRY_DSN: string;
  APP_VERSION: string;
  GIT_SHA: string;
}

// @ts-ignore
const appVars = ((window.__global_app_settings ||
  {}) as unknown) as AppEnvVariables;

export default appVars;
